export enum ActiveTab {
  SETTINGS_TAB,
  WORKFLOW_TAB,
  PERFORMANCE_TAB,
}

export type CampaignSectionDispatch = (action: CampaignSectionAction) => void;

export type CampaignSectionAction =
  | { type: 'CLEAR_SELECTED_CAMPAIGN' }
  | { type: 'SET_SELECTED_CAMPAIGN'; payload: { selectedCampaign: OnsiteCampaign } };

export interface OnsiteCampaign {
  id: string;
  name: string;
  updatedBy: string;
}

export interface CampaignSectionState {
  /** The currently selected campaign. */
  selectedCampaign: OnsiteCampaign;
}
